import { gql } from "@apollo/client";

export const GET_PROVIDER_MATERIAL_TRACEABILITY = gql`
  query GetUserGroupsWhereUnique($where: UserGroupWhereUniqueInput!) {
    getUserGroupsWhereUnique(where: $where) {
      availableMaterialTraceabilities {
        materialTraceability {
          id
          itemMaterialId
          itemMaterial {
            label
          }
          firstMaterialApprovalReference
          firstMaterialBrand
          firstMaterialCountry
          firstMaterialReference
          secondMaterialApprovalReference
          secondMaterialBrand
          secondMaterialCountry
          secondMaterialReference
          translatedName
        }
      }
    }
  }
`;

export const GET_ALL_MATERIAL_TRACEABILITY = gql`
  query GetAllMaterialTraceability {
    getAllMaterialTraceability {
      id
      firstMaterialReference
      firstMaterialBrand
      firstMaterialApprovalReference
      firstMaterialCountry
      secondMaterialReference
      secondMaterialBrand
      secondMaterialApprovalReference
      secondMaterialCountry
      itemMaterialId
      translatedName
    }
  }
`;

export const GET_ALL_MATERIAL_TRACEABILITY_WHERE = gql`
  query GetMaterialTraceabilityWhere($where: MaterialTraceabilityWhereInput) {
    getMaterialTraceabilityWhere(where: $where) {
      id
      firstMaterialReference
      firstMaterialBrand
      firstMaterialApprovalReference
      firstMaterialCountry
      secondMaterialReference
      secondMaterialBrand
      secondMaterialApprovalReference
      secondMaterialCountry
      itemMaterialId
      translatedName
    }
  }
`;

export const CREATE_MATERIAL_TRACEABILITY = gql`
  mutation CreateMaterialTraceability($args: MaterialTraceabilityCreateInput!) {
    createMaterialTraceability(args: $args) {
      id
    }
  }
`;
